import axios from 'axios';
import { VUE_APP_API_BASE_URL } from "@/config";

export const monitorMixin = {
  methods: {
    async monitorClicked(record) {
      await axios.post(`${VUE_APP_API_BASE_URL}/user/toggle-monitoring`, { user_id: record.id })
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message);
            // Call refresh method based on what's available in the component
            if (typeof this.getUsers === 'function') {
              this.getUsers();
            } else if (typeof this.getActivity === 'function') {
              this.getActivity();
            } else if (typeof this.getEmployees === 'function') {
              this.getEmployees();
            } else if (typeof this.pendingList === 'function') {
              this.pendingList();
            } else if (typeof this.getAttendance === 'function') {
              this.getAttendance();
            } else if (typeof this.searchClicked === 'function') {
              this.searchClicked();
            } else if (typeof this.getUserData === 'function') {
              this.getUserData();
            } else if (typeof this.pendingList === 'function') {
              this.pendingList();
            }
          } else {
            const errorMsg = response.data.message ?? "Error toggling monitoring";
            this.$toast.error(errorMsg);
            if (Object.prototype.hasOwnProperty.call(this, 'errorMessage')) {
              this.errorMessage = errorMsg;
            }
          }
        })
        .catch((error) => {
          console.error("Monitoring toggle error:", error);
          this.$toast.error("An error occurred while toggling monitoring");
        });
    },
  },
};
